import React, { useState } from 'react';
import placeholderPic from "assets/img/craft/craft-card-placeholder.svg";
import CommonItemInfo from "components/common-item/CommonItemInfo";

const TournamentBlock = ({ 
  tournamentSlots, 
  activeSlot, 
  setActiveSlot, 
  clearSlot, 
  canJoinTournament, 
  canCreateTournament 
}) => {
  const [isJoinTournament, setIsJoinTournament] = useState(false);

  const isDisabledCheck = (slot) => {
    // Similar logic to crafting - TPC slot disabled if no prediction selected
    if (!tournamentSlots[0].value && slot.placeholder === "TPC Wager") {
      return "disabled";
    }
    return "";
  };

  const getClearBtn = () => {
    if (tournamentSlots.some(slot => slot.value !== null)) {
      return (
        <button
          className="craft-block__clear"
          onClick={() => {
            tournamentSlots.forEach(slot => clearSlot(slot));
            setActiveSlot("Prediction");
          }}
        >
          Clear all slots
        </button>
      );
    }
    return null;
  };

  const isSubmitDisabled = () => {
    return !canJoinTournament && !canCreateTournament;
  };

  return (
    <section className="craft-block">
      <header className="craft-block__header">
        <section className="craft-block__header-info">
          <h1 className="craft-block__title">Join Tournament</h1>
          <p className="craft-block__descr">
            Select a Prediction from your inventory and choose a TPC wager amount to join or create a tournament.
          </p>
        </section>
        <div className="craft-block__actions">
          {getClearBtn()}
          <button
            className="craft-block__submit"
            disabled={isSubmitDisabled()}
            onClick={() => setIsJoinTournament(true)}
          >
            {canJoinTournament ? "Join Tournament" : canCreateTournament ? "Create Tournament" : "Enter Tournament"}
          </button>
        </div>
      </header>
      
      <ul className="craft-block__steps">
        {tournamentSlots.map((slot) => (
          <li
            className={`craft-block__step ${
              slot.placeholder === activeSlot ? "active" : ""
            } ${isDisabledCheck(slot)}`}
            key={slot.placeholder}
            onClick={() => setActiveSlot(slot.placeholder)}
          >
            {slot.value === null ? (
              <p className="craft-block__step-empty">
                <img src={placeholderPic} alt="" />
                <span>{slot.placeholder}</span>
              </p>
            ) : (
              <div className="craft-block__step-selected">
                <CommonItemInfo
                  image={slot.value.image}
                  name={slot.value.name}
                  props={slot.value.properties}
                  type={slot.value.type}
                />
                <p className="cards-list__block-item-text">
                  {slot.value.type.toLowerCase() === "tpc wager"
                    ? "$" + slot.value.name
                    : slot.value.name}
                </p>
                <span className="craft-block__step-tag">
                  {slot.value.type}
                </span>
                <button
                  className="craft-block__step-clear"
                  onClick={(e) => {
                    e.stopPropagation();
                    clearSlot(slot);
                  }}
                >
                  Clear
                </button>
              </div>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default TournamentBlock;
